<div class="modal" [ngClass]="{ 'is-active': open }">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 550px">
    <header class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="TEMPLATE_TAGS"
      >
        {{ 'TEMPLATE_TAGS' | translate }}
      </span>
      <button
        class="delete"
        aria-label="close"
        (click)="onClose.emit()"
      ></button>
    </header>
    <section
      class="modal-card-body"
      style="
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        min-height: 300px;
        max-height: 60vh;
      "
    >
      <form autocomplete="off" class="form">
        <div class="field is-narrow">
          <label class="label" translationEditableDirective="TEMPLATE">{{
            'TEMPLATE' | translate
          }}</label>
          <div class="control" style="width: 300px">
            <ng-select
              [translationEditableModalDirective]="templatesTranslateKeys"
              [translationEditableModalDirectiveDefaults]="
                templatesTranslateDefaults
              "
              [items]="templates"
              name="template"
              [multiple]="false"
              [closeOnSelect]="true"
              bindLabel="title"
              bindValue="name"
              (change)="onTemplateChange($event)"
            >
              <ng-template ng-label-tmp let-item="item">
                {{
                  item.type.translationKey
                    | translate : { defaultValue: item.type.title }
                }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{
                  item.type.translationKey
                    | translate : { defaultValue: item.type.title }
                }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </form>
      <table class="table mt-4" *ngIf="tags.length">
        <thead>
          <tr>
            <th translationEditableDirective="TAG">
              {{ 'TAG' | translate }}
            </th>
            <th translationEditableDirective="TITLE">
              {{ 'TITLE' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tag of tags">
            <td>
              <code
                ><span>&#123;&#123;</span>{{ tag.tag
                }}<span>&#125;&#125;</span></code
              >
            </td>
            <td
              [translationEditableDirective]="tag.trnKey"
              [translationEditableDirectiveDefault]="tag.title"
            >
              {{
                translateService.instant(tag.trnKey, {
                  defaultValue: tag.title
                })
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</div>
